import CONTACT from "./contact";

export default CONTACT;
